<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">单双大小历史</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <div v-if="dxdsHistoryStatsList" class="content-8__content">
        <div class="table-scroll">
          <table class="even-color">
            <thead>
              <tr>
                <th rowspan="2">日期</th>
                <th
                  v-for="column in columnKeys"
                  :key="column.key"
                  :colspan="column.colSpan"
                >{{ column.columnLabel }}</th>
              </tr>
              <tr>
                <template v-for="colIndex in columnKeys.length">
                  <template v-for="subCol in subColKeys">
                    <th :key="`${colIndex}-${subCol.key}`">{{ subCol.label }}</th>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rowData in dxdsHistoryStatsList" :key="rowData.date">
                <td>{{ rowData.date }}</td>
                <template v-for="column in columnKeys">
                  <template v-for="subCol in subColKeys">
                    <td
                      :key="`tbody-${column.key}-${subCol.key}`"
                    >{{ rowData[column.key][subCol.key] === '-' ?
                      rowData[column.key][subCol.key] : Math.abs(rowData[column.key][subCol.key]) }}</td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { fieldList } from '@/utils/forWeb-Sean/danShuangDaXiao'
import { getCPStatistics_web } from '@/api/desktop/statistic'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'WebDanShuangDaXiaoLiShi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      isLoading: true,
      lotteryCode: this.$route.params.lottery_code,
      dxdsHistoryStatsList: null
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.getDXDSHistoryStatistics(this.lotteryCode)
  },
  methods: {
    async getDXDSHistoryStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(code, 'dxdsHistory', {
        days: 30,
        rules: 'hmDanShuang,hmDaXiao'
      })
      if (error) return
      // console.log(this.makeUpForTableList(data))
      this.dxdsHistoryStatsList = this.makeUpForTableList(data).map((each) =>
        Object.assign({}, { date: each.date, ...each.countList })
      )
      this.isLoading = false
    },
    makeUpForTableList(data) {
      /* 這裡為配合後端資料，須先判斷
      1. 統計資料是否為空 (為空則顯示 "-")
      2. 是否沒有這個欄位資料 (ex: 冠亞和 和 沒有統計值，需給0)
      */
      return data.map(each => {
        const formatCountList = {}
        const isNullData = Object.keys(each.countList).length === 0
        if (isNullData) {
          this.columnKeys.forEach(column => {
            formatCountList[column.key] = this.subColKeys.reduce((returnObj, subCol) => Object.assign(returnObj, { [subCol.key]: '-' }), {})
          })
        } else {
          this.columnKeys.forEach(column => {
            formatCountList[column.key] = this.subColKeys.reduce((returnObj, subCol) =>
              Object.assign(returnObj, { [subCol.key]: each.countList[column.key][subCol.key] ? Math.abs(each.countList[column.key][subCol.key]) : 0 }), {})
          })
        }
        return {
          date: each.date,
          countList: formatCountList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  font-size: 0.75rem;
}
</style>
